import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

export const getPopupContentStyle = (isMobile: boolean) => ({
  width: isMobile ? '100%' : 'auto',
  height: isMobile ? '100%' : 'auto',
  padding: isMobile ? '1.25rem 1.25rem 1.375rem' : '1.5rem 1.875rem 1.375rem',
});

export const ControlsWrapStyled = styled(FlexContainer)`
  margin-top: 2.5rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-top: 6rem;
    }
  `}
`;

export const ActionBtnStyled = styled(Button)`
  height: 48px;
  flex: 1 1;
  font-size: ${({ theme }) => theme.fontSize['2xl']};

  &:first-child {
    margin-right: 1rem;
  }

  ${({ theme }) => `
    ${theme.devices.tablet} {    
      width: 140px;
      height: 38px;
      flex: none;
      font-size: ${theme.fontSize.lg};
    }
  `}
`;

export const FlexContainerMessageStyled = styled(FlexContainer)`
  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 0 2.5rem 0.625rem;
    }
  `}
`;

export const TypographyTitleStyled = styled(Typography)`
  margin-bottom: 1.875rem;
`;

export const FormStyled = styled.form`
  width: 100%;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      width: 100%;
    }
  `}
`;

export const FormElementWrapStyled = styled.div`
  margin-bottom: 1rem;
`;
